import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import { AgencyNameContainer } from '../InviteAgencyModal.styles';

const NoAgenciesAvailable = () => (
  <AgencyNameContainer>
    <Text color="secondaryText" data-name="no-agencies-available" size="normal">
      No agencies available for pairing
    </Text>
  </AgencyNameContainer>
);

export default NoAgenciesAvailable;
